<!--
 * @Description: 报修 详情
 * @Author: PF
 * @Date: 2023-12-13 09:51:16.207
 * @LastEditors: PF
 * @LastEditTime: 2024-07-10 13:49:30
-->
<template>
  <div>
    <el-dialog class="w800 h630" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Document />
          </el-icon>
          <span class="header-title">详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-descriptions :column="2" border>
        <el-descriptions-item label="标题" label-align="right" align="left" width="100px" span="2">{{ruleForm.bt}}</el-descriptions-item>
        <el-descriptions-item label="地点" label-align="right" align="left" width="100px" span="2">{{ruleForm.dd}}</el-descriptions-item>
        <el-descriptions-item label="描述" label-align="right" align="left" width="100px" span="2">{{ruleForm.ms}}</el-descriptions-item>
        <el-descriptions-item label="处理状态" label-align="right" align="left" width="100px" span="2"><span v-if="ruleForm.clzt">{{ruleForm.clzt.name}}</span></el-descriptions-item>
        <el-descriptions-item label="维修人员" label-align="right" align="left" width="100px" span="2">{{ruleForm.wxryxm}}</el-descriptions-item>
        <el-descriptions-item label="维修意见" label-align="right" align="left" width="100px" span="2">{{ruleForm.wxyj}}</el-descriptions-item>
        <el-descriptions-item label="维修结果" label-align="right" align="left" width="100px" span="2">{{ruleForm.wxjg}}</el-descriptions-item>
        <el-descriptions-item label="维修时间" label-align="right" align="left" width="100px" span="2">{{ruleForm.wxsj}}</el-descriptions-item>
        <el-descriptions-item label="退回说明" label-align="right" align="left" width="100px" span="2">{{ruleForm.thsm}}</el-descriptions-item>
        <el-descriptions-item label="附件" label-align="right" align="left" width="100px" span="2">
          <span style="color: #409EFF;cursor: pointer;" @click="openFuJian=true">预览</span>
        </el-descriptions-item>
      </el-descriptions>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="info" @click="closeWindow('openDetail', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
  <fujian v-if="openFuJian" v-model:openDetail="openFuJian" :row="{listFj:ruleForm.listFuJian||[]}" />
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { loadData, closeWindow } from '@/api/common.js'
import fujian from '@/components/fujian.vue'

const props = defineProps({
  openDetail: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openDetail'])
const ruleForm = ref({ clzt: {} })

const openFuJian = ref(false)
watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      loadData({ url: '/api/v2/houqin/baoxiu/' + props.row.id, ruleForm })
    }
  },
  { deep: true, immediate: true }
)
</script>
